import SingleSelector from "../SingleSelector";
import { useTranslation } from "@/langs/useTranslation";

const TriggerStatus = ({ name, value, onChange }) => {
  const { t } = useTranslation();

  return (
    <SingleSelector
      placeholder={t({ defaultMessage: "选择状态" })}
      clearable
      options={[
        { id: 1, name: t({ defaultMessage: "已触发" }) },
        { id: 2, name: t({ defaultMessage: "未触发" }) }
      ]}
      name={name}
      value={value}
      onChange={onChange}
    />
  );
};

export default TriggerStatus;
